export const SubscriptionPaymentStatus = {
    OK: "OK",
    FAILED: "FAILED",
    WAITING_FOR_FIRST_PAYMENT: "WAITING_FOR_FIRST_PAYMENT",
}
